import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';

import { getUserAvatarThumb } from 'utilities/avatar';

import GetUserWithProfileInfo from '../../user-profile/profile-card/GetUserWithProfileInfo.graphql';

import ProfileCard from 'components/user-profile/profile-card';

import styles from './styles.module.less';

const propTypes = {
  teamMember: PropTypes.object,
  name: PropTypes.string.isRequired,
  // optional props if teamMember is not provided
  profileId: PropTypes.string,
  avatarSrc: PropTypes.string,
  highlightText: PropTypes.bool,
};

const MentionPill = ({
  teamMember,
  name,
  profileId,
  avatarSrc,
  highlightText = true,
}) => {
  const { data: userProfileData } = useQuery(GetUserWithProfileInfo, {
    variables: {
      userId: teamMember?.id,
    },
    fetchPolicy: 'no-cache',
    skip: !teamMember,
  });

  if (!teamMember && !profileId) {
    return (
      <div className={highlightText ? styles.mention : styles.mention_default}>
        {`@${name}`}
      </div>
    );
  }

  const avatar = avatarSrc || getUserAvatarThumb(teamMember.avatars);

  return (
    <div className={highlightText ? styles.mention : styles.mention_default}>
      <ProfileCard
        avatarSrc={avatar}
        name={name}
        profileId={profileId || teamMember.id}
        hasFocus
        useLoomSSRVideo={false}
        placement="top-center"
        cachedUserProfileData={userProfileData}
      >
        {name}
      </ProfileCard>
    </div>
  );
};

MentionPill.propTypes = propTypes;

export default MentionPill;
